import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { LoanDetailsListTracker } from './loan-details-data';

@Injectable({
    providedIn: 'root',
})
export class LoanDetailsListOfLoansService {
    private listOfLoansSource = new BehaviorSubject<LoanDetailsListTracker>(null);
    currentListOfLoans = this.listOfLoansSource.asObservable();

    constructor() {}

    changeListOfLoans(listOfLoansTracker: LoanDetailsListTracker) {
        this.listOfLoansSource.next(listOfLoansTracker);
    }
}
